<template>
<div class="routeplanner-widget" v-bind:class="{ showResults: showResults }">
    <div v-if="!showResults" class="route-details">
        <h3>Select your Journey</h3>
        <form @submit.prevent="getDirections">
            <div class="select-container" style="position: relative;">
                <stations-dropdown name="origin" :stations="this.stations"></stations-dropdown>
                <div class="select-icon"><p class="select-icon-label">FROM</p></div>
            </div>
            <div class="select-container" style="position: relative;">
                <stations-dropdown name="destination" :stations="this.stations"></stations-dropdown>
                <div class="select-icon"><p class="select-icon-label">TO</p></div>
            </div>
            <div class="select-container" style="position: relative;">
                <transport-dropdown name="transport"></transport-dropdown>
                <div class="select-icon transport-icon"><p class="select-icon-label">TRANSPORT</p></div>
            </div>
            <button type="submit" name="submit">SEE RESULTS</button>
        </form>
    </div>
    <div v-else class="route-results">
        <h3 class="blue-heading">Your Journey<span><img :src="require('../assets/img/icons/blue_'+this.transportType+'.png')"></span></h3>
        <h4 class="grey-text">{{this.transportTypes[this.transportType].description}} from</h4>
        <p class="station-label">{{this.from}} <span class="grey-text">to</span></p>
        <p style="margin-bottom: 20px !important;" class="station-label">{{this.to}}</p>
        <p class="total-distance result-label">{{this.currentRoute.savingsData.distance_miles}}les</p>
        <p class="time-taken result-label">{{this.currentRoute.savingsData.time_taken}} mins</p>
        <p class="calories-burnt result-label">{{this.currentRoute.savingsData.calories}} calories</p>
        <p class="co2-saved result-label">{{this.currentRoute.savingsData.co2_saved}}<span style="text-transform: lowercase;">G</span> co<sub>2</sub> saved*</p>
        <p class="money-saved result-label">£{{this.currentRoute.savingsData.money_saved}} saved**</p>
        <p></p>
        <p></p>
        <p></p>
        <button type="submit" name="submit" v-on:click="this.resetRoute">Restart</button>
    </div>
</div>

</template>

<script>

import StationsDropdown from './StationsDropdown.vue';
import TransportDropdown from './TransportDropdown.vue';
import gmapsInit from '../gmaps';

import json from '../assets/data/tubestations_latLng.json';
import transportJson from '../assets/data/transportModes.json';

export default {
  name: 'RoutePlanner',
  components: {
      StationsDropdown,
      TransportDropdown
  },
  data() {
      return {
          stations: json,
          transportTypes: transportJson,
          directionsService: false,
          unitSystem: false,
          from: false,
          to: false,
          currentRoute: [],
          showingResults: false,
          transportType: false
      }
  },
    async mounted() {
    try {
        const google = await gmapsInit();
    
        this.directionsService = new google.maps.DirectionsService();
        this.unitSystem = google.maps.UnitSystem.IMPERIAL;
        } catch (error) {
        console.error(error);
        }
    },
    computed: {
        showResults() {
            return this.showingResults;
        }
    },
    methods : {
        resetRoute() {
            this.showingResults = false;
        },
        getDirections(submitEvent) {
        //lat and long for the route i am plotting
        let formInputs = submitEvent.target.elements;
        let formData = [];
        formInputs.forEach((input) => {
            let fieldValue = false;
            if(input.name !='submit') {
                if(input.name == 'transport') {
                    fieldValue = input.value;
                    this.transportType = fieldValue;
                } else {
                    //the name of the inputs station
                    let station = this.stations[input.value];
                    //station latLng concatenated
                    fieldValue = station.latitude+','+station.longitude;
                    formData[input.name+'_label'] = station.stationname;
                    formData[input.name+'_zone'] = station.zone;
                }
                formData[input.name] = fieldValue;
            }
            this.from = formData.origin_label;
            this.to = formData.destination_label;
        });
        this.calculateAndDisplayRoute(formData);
        },
        calculateAndDisplayRoute(formData) {
            const self = this;
            //plot route using google maps directionsService API
            this.directionsService.route({
                //from
                    origin: {
                        query: formData['origin']
                    },
                //to
                    destination: {
                        query: formData['destination']
                    },
                    //plot route on foot
                    travelMode: "WALKING",
                    unitSystem: this.unitSystem,
                    avoidFerries: true,
                },
                function(response, status) {
                    
                    if (status === "OK") {
                        self.currentRoute = response;
                        let distance = response.routes[0].legs[0].distance;console.log(response.routes[0].legs[0].distance);
                        let savingsData = self.calculateSavings(distance, formData);
                        self.currentRoute.savingsData = savingsData; 
                        self.showingResults = true;
                    } else {
                        window.alert("Directions request failed due to " + status);
                    }
                }
            )
        },
        calculateSavings(distance, formData) {
            let data = {};
            let transportData = this.transportTypes[this.transportType];
            let distanceMiles = distance.value / 1609.34;

            data.calories = Math.round(transportData.calories_per_mile * distanceMiles);
            data.time_taken = Math.round(transportData.mins_per_mile * distanceMiles);
            data.co2_saved = Math.round(transportData.co2_saved * distanceMiles);
            data.distance_miles = distance.text;

            let fromZone = formData['origin_zone'];
            let toZone = formData['destination_zone'];

            let nearestZone = fromZone
            let furthestZone = toZone;

            if(fromZone > toZone) {
                furthestZone = fromZone;
                nearestZone = toZone;
            }
            if(nearestZone == 1) {
                switch(furthestZone) {
                    case 1: data.money_saved = "2.40";
                    break;
                    case 2: data.money_saved = "2.40 - £2.90";
                    break;
                    case 3: data.money_saved = "2.80 - £3.30";
                    break;
                    case 4: data.money_saved = "2.80 - £3.90";
                    break;
                    case 5: data.money_saved = "3.10 - £4.70";
                    break;
                    default:  data.money_saved = "3.10 - £5.10";
                    break;
                }
            } else if(nearestZone == furthestZone | furthestZone - nearestZone == 1) {//same or adjacent zone
                data.money_saved = "1.50 - £1.70";
            } else {
                data.money_saved = "1.50 - £2.80";
            }
            return data;
        }
    }
}

</script>
<style scoped>
    .routeplanner-widget {
        background: #004876;
        width: 290px;
        border-radius: 8px;
        padding: 16px;
        position: fixed;
        left: 25px;
        top: 10px;
    }
    .routeplanner-widget.showResults {
        background: white;
        color: black;
        filter: drop-shadow(0 2px 6px #bbb);


    }
    h3 {
        font-style: italic;
    }
    h3,button {
        font-family: "Roboto Condensed", sans-serif;
        font-weight: bold;
        font-size: 20px;
        color: white;
        text-transform: uppercase;
        margin: 0;
        margin-bottom: 16px;
        line-height: 1.5;
    }
    h3.blue-heading {
        color: #004876;
    }
    .grey-text {
        color: #707070;
    }
    h3 >span {
        position: absolute;
        right: 16px;
    }
    h3 > span >img {
        width: 50px;
        max-height: 35px;
        object-fit: contain;
    }
    h4 {
        font-size: 12px;
        line-height: auto;
        font-weight: bold;
    }
    .route-results {
        font-family: "Roboto Condensed", sans-serif;
        font-weight: bold;
        text-transform: uppercase;
        line-height: auto;
    }
    .route-results p.station-label {
        margin: 0 !important;
    }
    button {
        background: #EC6607;
        border: 2px solid #E38A4A;
        border-radius: 8px;
        padding: 8px 0;
        margin-top: 8px;
        margin-bottom: 2px;
        width: 100%;
    }
    .result-label {
        padding-left: calc(25px + 16px);
        margin-bottom: 4px;
    }
    .result-label:before {
        content: '';
        display: block;
        width: 29px;
        left: 16px;
        position: absolute;
        background-size: contain;
        min-height: 22px;
        background-repeat: no-repeat;
        background-position: center;
    }

    .time-taken:before {
        background-image: url('../assets/img/icons/stopwatch.png');
    }
    .co2-saved:before {
        background-image: url('../assets/img/icons/co2.png');

    }
    .money-saved:before {
        background-image: url('../assets/img/icons/piggybank.png');

    }
    .calories-burnt:before {
        background-image: url('../assets/img/icons/calories.png');

    }
    .total-distance:before {
        background-image: url('../assets/img/icons/distance.png');

    }
    .select-icon {
        background-image: url('../assets/img/icons/tram_station.png');
        background-size: contain;
        background-repeat: no-repeat;
        position: absolute;
        width: 26px;
        height: 26px;
        top: -9px;
        left: 11px;
    }
    .select-icon.transport-icon {
        background-image: url('../assets/img/icons/walking.png');
    }
    .select-icon-label {
        position: absolute;
        top: -4px;
        left: 34px;
        font-size: 12px;
        font-weight: bold;
        color: #707070;
        line-height: 16px;
        margin: 0;
    }


    select {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        padding: .5em;
        border: none;
        border-radius: 12px;
        padding: 20px 16px 10px 42px;
        font-size: 1em;
        padding-left: 45px;
        border: 2px solid #E0E0E0;
        border-radius: 8px;
        width: 100%;
        margin-bottom: 8px;
        font-weight: 600;
        outline: none;
    }
    .select-container {position:relative; display: inline;}
    .select-container:after {content:""; width:0; height:0; position:absolute; pointer-events: none;}
    .select-container:after {
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        top: 0;
        right: .75em;
        border-top: 8px solid black;
        opacity: 0.5;
    }
    select::-ms-expand {
        display: none;
    }

    @media(max-width: 600px) {
        .routeplanner-widget {
            top: auto;
            bottom: 14px;
            left: 15px;
            right: 15px;
            width: calc(100% - 30px);
        }
    }
    p.station-label {
    line-height: 1;
}

</style>